export default "__VITE_ASSET__8cb81d1c__"